module.exports = __webpack_public_path__ + "assets/8a2ce3f85c866c899b64c163ec4178ba.png";